import { computeCorrectScore, getCounts, getTags, getText } from "./helper";
import {
  calculateOverOptimizedScore,
  calculateWellOptimizedScore,
  countMatches,
  semanticsScoreWeights,
  semanticsScoreWeightsWithOptScores,
} from "./semanticHelper";

// Keyword Density Check
const keywordDensityCheck = (formikProps) => {
  let query = getText(formikProps.values.seo_request.trim()).trim();
  let text = getText(
    formikProps.values.h1_title.trim() +
      formikProps.values.introduction.trim() +
      formikProps.values.content.trim() +
      formikProps.values.conclusion.trim()
  )
    .toLowerCase()
    .trim();
  const wordCount = getCounts(text).words;

  let matchCount = countMatches(query, text);
  if (query.length == 0 || text.length == 0) {
    return {
      score: -1,
      percentage: 0,
      matchCount: 0,
      queryLength: query.length,
      wordCount: 0,
    };
  }
  const score = ((matchCount / wordCount) * 100).toFixed(2);

  if (score < 0.5 || score > 3) {
    return {
      score: 0,
      percentage: score,
      matchCount: matchCount,
      queryLength: query.length,
      wordCount: wordCount,
    };
  }
  if ((score >= 0.5 && score < 1) || (score > 2 && score <= 3)) {
    return {
      score: 50,
      percentage: score,
      matchCount: matchCount,
      queryLength: query.length,
      wordCount: wordCount,
    };
  }
  if (score >= 1 && score <= 2) {
    return {
      score: 100,
      percentage: score,
      matchCount: matchCount,
      queryLength: query.length,
      wordCount: wordCount,
    };
  }
};

// Keyword Placement Check
const keywordPlacementCheck = (formikProps) => {
  let query = getText(formikProps.values.seo_request.trim()).trim();
  let introduction = getText(formikProps.values.introduction.trim())
    .toLowerCase()
    .trim();
  let content = getTags(formikProps.values.content.trim())
    .filter((x) => x.tag.toLowerCase() === "h2")
    .map((x) => x.content)
    .join(" ")
    .trim();
  let conclusion = getText(formikProps.values.conclusion.trim())
    .toLowerCase()
    .trim();
  if (
    (introduction.length == 0 &&
      content.length == 0 &&
      conclusion.length == 0) ||
    query.length == 0
  ) {
    return {
      score: -1,
      percentage: -1,
      queryLength: query.length,
      checks: [],
      text:
        query.length == 0 ? "Target request not found" : "Please add content",
    };
  }
  const checks = [
    {
      name: "Introduction",
      value: countMatches(query, introduction) > 0 ? true : false,
    },
    {
      name: "H2",
      value: countMatches(query, content) > 0 ? true : false,
    },

    {
      name: "Conclusion",
      value: countMatches(query, conclusion) > 0 ? true : false,
    },
  ];
  let success = checks.filter((x) => x.value == true).length;

  const score = (success / 3) * 100;

  if (success === 3) {
    return {
      score: 100,
      queryLength: query.length,
      checks: checks,
      percentage: score,
    };
  } else if (success == 2) {
    return {
      score: 50,
      queryLength: query.length,
      checks: checks,
      percentage: score,
    };
  } else {
    return {
      score: 0,
      queryLength: query.length,
      checks: checks,
      percentage: score,
    };
  }
};

// Score Calculation
  export const  startSemanticAnalysis = (formikProps, competitorResults) => {
    const keywordDensity = keywordDensityCheck(formikProps);
    const keywordPlacement = keywordPlacementCheck(formikProps);
    let totalScore = computeCorrectScore(
      [keywordDensity.score, keywordPlacement.score],
      semanticsScoreWeights
    );
    if (competitorResults?.keywords_analysis?.secondary_keywords.length > 0) {
      const wellOptimizedScore = calculateWellOptimizedScore(
        competitorResults?.keywords_analysis,
        formikProps
      );
      const overOptimizedScore = calculateOverOptimizedScore(
        competitorResults?.keywords_analysis,
        formikProps
      );

      totalScore = computeCorrectScore(
        [
          keywordDensity.score,
          keywordPlacement.score,
          wellOptimizedScore,
          overOptimizedScore,
        ],
        semanticsScoreWeightsWithOptScores
      );
    }

    return {
      keyword_density: keywordDensity,
      keyword_placement: keywordPlacement,
      total_score: Math.round(totalScore),
    };
  };
